// TEMPERATURE
export const FETCHING_CURRENT_TEMPERATURE_AVERAGE = 'fetching:current-temperature-average';
export const FETCH_CURRENT_TEMPERATURE_AVERAGE = 'fetch:current-temperature-average';
export const FETCH_CURRENT_TEMPERATURE_FAILURE = 'fetch-current-temperature-failure';

export const FETCHING_PERIOD_TEMPERATURE_AVERAGE = 'fetching:period-temperature-average';
export const FETCH_PERIOD_TEMPERATURE_AVERAGE = 'fetch:period-temperature-average';
export const FETCH_PERIOD_TEMPERATURE_FAILURE = 'fetch-period-temperature-failure';

export const FETCHING_HISTORICAL_TEMPERATURE_AVERAGE = 'fetching:historical-temperature-average';
export const FETCH_HISTORICAL_TEMPERATURE_AVERAGE = 'fetch:historical-temperature-average';
export const FETCH_HISTORICAL_TEMPERATURE_FAILURE = 'fetch-historical-temperature-failure';

export const CLEANUP_TEMPERATURE = 'cleanup:temperature';

// SPI-4
export const FETCHING_CURRENT_SPI4_AVERAGE = 'fetching:current-SPI4-average';
export const FETCH_CURRENT_SPI4_AVERAGE = 'fetch:current-SPI4-average';
export const FETCH_CURRENT_SPI4_FAILURE = 'fetch-current-SPI4-failure';

export const FETCHING_PERIOD_SPI4_AVERAGE = 'fetching:period-SPI4-average';
export const FETCH_PERIOD_SPI4_AVERAGE = 'fetch:period-SPI4-average';
export const FETCH_PERIOD_SPI4_FAILURE = 'fetch-period-SPI4-failure';

export const FETCHING_HISTORICAL_SPI4_AVERAGE = 'fetching:historical-SPI4-average';
export const FETCH_HISTORICAL_SPI4_AVERAGE = 'fetch:historical-SPI4-average';
export const FETCH_HISTORICAL_SPI4_FAILURE = 'fetch-historical-SPI4-failure';

export const CLEANUP_SPI4 = 'cleanup:SPI4';
